import React from 'react'
import PropTypes from 'prop-types'
import useOperation from './hooks/use-operation'
import ModelContext from './contexts/ModelContext'
import { observable } from 'mobx'
import useOperations from './hooks/use-operations'
import useUUID from './hooks/use-uuid'

function ReadOnlyModel (props) {
  const modelRef = React.useRef(observable.map())
  const model = modelRef.current

  const repository = useOperations()
  const parentOperation = useOperation()
  const [uuid] = useUUID()

  const namespace = props.namespace
  const operationName = props.operationName
  const operationContext = props.operationContext
  const resourceName = (!props.resourceName && !!parentOperation) ? parentOperation.resource.slug : props.resourceName

  const [operationSlug, setOperationSlug] = React.useState(null)

  React.useEffect(() => {
    const currentOperationSlug = repository.buildSlug(namespace, resourceName, operationName, operationContext)

    if (operationSlug !== currentOperationSlug) {
      setOperationSlug(currentOperationSlug)
    }
  }, [namespace, resourceName, operationName, operationContext])

  React.useEffect(() => {
    if (!operationSlug) {
      return
    }

    const operation = repository.get(namespace, resourceName, operationName, operationContext)

    const newModel = (operation.data && operation.data.model) ? operation.data.model : {}
    model.replace(newModel)

    operation.onData(uuid, (data) => {
      const newModel = (data && data.model) ? data.model : {}
      model.replace(newModel)
    })

    return () => {
      operation.unsetOnDataCallback(uuid)
    }
  }, [operationSlug])

  return (
    <ModelContext.Provider value={model}>
      {props.children}
    </ModelContext.Provider>
  )
}

ReadOnlyModel.defaultProps = {
  namespace: 'api',
  resourceName: null,
  operationName: 'read',
  operationContext: null
}

ReadOnlyModel.propTypes = {
  namespace: PropTypes.string,
  resourceName: PropTypes.string,
  operationName: PropTypes.string,
  operationContext: PropTypes.any
}

export default ReadOnlyModel
